import ActsService from '@/services/apiRequests/acts.service';

export default {
    namespaced: true,
    state: {
        contracts: {
            acts: [],
            rowCount: 0,
            isLoading: false,
            page: 0,
            itemsPerPage: 5,
            filter: {
                contract_number: null,
                address_rid: null,
                date_begin: null,
                date_end: null,
                is_connected_gvs: null,
                is_connected_heat: null,
                is_debtor: null,
                engineer_rid: null,
                contractor_name: null
            }
        },
        accounts: {
            acts: [],
            rowCount: 0,
            isLoading: false,
            page: 0,
            itemsPerPage: 5,
            filter: {
                account_number: null,
                address_rid: null,
                date_begin: null,
                date_end: null,
                is_connected_gvs: null,
                is_connected_heat: null,
                is_debtor: null,
                engineer_rid: null
            }
        }
    },
    getters: {
        getContractActs(state) {
            return state.contracts.acts;
        },
        getContractRowCount(state) {
            return state.contracts.rowCount;
        },
        getContractIsLoading(state) {
            return state.contracts.isLoading;
        },
        getContractPage(state) {
            return state.contracts.page;
        },
        getContractItemsPerPage(state) {
            return state.contracts.itemsPerPage;
        },
        getAccountActs(state) {
            return state.accounts.acts;
        },
        getAccountRowCount(state) {
            return state.accounts.rowCount;
        },
        getAccountIsLoading(state) {
            return state.accounts.isLoading;
        },
        getAccountPage(state) {
            return state.accounts.page;
        },
        getAccountItemsPerPage(state) {
            return state.accounts.itemsPerPage;
        }
    },
    mutations: {
        setContractActs(state, acts) {
            state.contracts.acts = acts;
        },
        setContractRowCount(state, rowCount) {
            state.contracts.rowCount = rowCount;
        },
        setContractIsLoading(state, isLoading) {
            state.contracts.isLoading = isLoading;
        },
        setContractPage(state, page) {
            state.contracts.page = page;
        },
        setContractFilter(state, filter) {
            state.contracts.filter = filter;
        },
        setAccountActs(state, acts) {
            state.accounts.acts = acts;
        },
        setAccountRowCount(state, rowCount) {
            state.accounts.rowCount = rowCount;
        },
        setAccountIsLoading(state, isLoading) {
            state.accounts.isLoading = isLoading;
        },
        setAccountPage(state, page) {
            state.accounts.page = page;
        },
        setAccountFilter(state, filter) {
            state.accounts.filter = filter;
        }
    },
    actions: {
        async getContractActsData({ state, commit }) {
            const {
                contract_number,
                address_rid,
                date_begin,
                date_end,
                is_connected_gvs,
                is_connected_heat,
                is_debtor,
                signed,
                engineer_rid,
                contractor_name
            } = state.contracts.filter;
            const is_signed = signed === 1 ? true : signed === 0 ? false : null;
            const payloadData = {
                currentItem: state.contracts.page,
                itemsPerPage: state.contracts.itemsPerPage,
                iWhereOrderLocale: {
                    where: [
                        { field: 'contract_number', value: contract_number },
                        { field: 'address_rid', value: address_rid },
                        { field: 'date_begin', value: date_begin },
                        { field: 'date_end', value: date_end },
                        { field: 'is_connected_gvs', value: is_connected_gvs },
                        { field: 'is_connected_heat', value: is_connected_heat },
                        { field: 'is_debtor', value: is_debtor },
                        { field: 'signed', value: is_signed },
                        { field: 'engineer_rid', value: engineer_rid },
                        { field: 'contractor_name', value: contractor_name }
                    ]
                }
            };
            commit('setContractIsLoading', true);
            const response = await ActsService.getContractActs(payloadData);
            commit('setContractIsLoading', false);
            if (!response) return;
            commit('setContractActs', response.data['ahs_contracts'] || []);
            commit('setContractRowCount', response.data.pagination['row_count']);
        },
        async getAccountActsData({ state, commit }) {
            const {
                account_number,
                address_rid,
                date_begin,
                date_end,
                is_connected_gvs,
                is_connected_heat,
                is_debtor,
                signed,
                engineer_rid
            } = state.accounts.filter;
            const is_signed = signed === 1 ? true : signed === 0 ? false : null;
            const payloadData = {
                currentItem: state.accounts.page,
                itemsPerPage: state.accounts.itemsPerPage,
                iWhereOrderLocale: {
                    where: [
                        { field: 'account_number', value: account_number },
                        { field: 'address_rid', value: address_rid },
                        { field: 'date_begin', value: date_begin },
                        { field: 'date_end', value: date_end },
                        { field: 'is_connected_gvs', value: is_connected_gvs },
                        { field: 'is_connected_heat', value: is_connected_heat },
                        { field: 'is_debtor', value: is_debtor },
                        { field: 'signed', value: is_signed },
                        { field: 'engineer_rid', value: engineer_rid }
                    ]
                }
            };
            commit('setAccountIsLoading', true);
            const response = await ActsService.getAccountActs(payloadData);
            commit('setAccountIsLoading', false);
            if (!response) return;
            commit('setAccountActs', response.data['ahs_contracts'] || []);
            commit('setAccountRowCount', response.data.pagination['row_count']);
        },
        setContractActsFilter({ state, commit }, filter) {
            const { address, date, id, ...rest } = filter;
            const payload = {
                ...rest,
                contract_number: id,
                address_rid: address.record_id ? address.record_id : null,
                date_begin: date ? date[0] : null,
                date_end: date ? date[1] ?? date[0] : null
            };
            commit('setContractFilter', payload);
        },
        setAccountActsFilter({ state, commit }, filter) {
            const { address, date, id, ...rest } = filter;
            const payload = {
                ...rest,
                account_number: id,
                address_rid: address.record_id ? address.record_id : null,
                date_begin: date ? date[0] : null,
                date_end: date ? date[1] ?? date[0] : null
            };
            commit('setAccountFilter', payload);
        },
        async printContractActPdf({ state }, selectedActs) {
            const payload = { acts: selectedActs };
            const response = await ActsService.printPdfContractAct(payload);

            const base64EncodedPDF = response.data;
            const newWindow = window.open();

            newWindow.document.write('<iframe width="100%" height="100%" src="data:application/pdf;base64,' + base64EncodedPDF + '"></iframe>');

            newWindow.onload = function() {
                newWindow.print();
            };
        },
        async printAccountActPdf({ state }, selectedActs) {
            const payload = { acts: selectedActs };
            const response = await ActsService.printPdfAccountAct(payload);

            const base64EncodedPDF = response.data;
            const newWindow = window.open();

            newWindow.document.write('<iframe width="100%" height="100%" src="data:application/pdf;base64,' + base64EncodedPDF + '"></iframe>');

            newWindow.onload = function() {
                newWindow.print();
            };
        }
    }
};
